__turbopack_context__.v({
  "disclaimer": "styles-module-scss-module__uq-5CW__disclaimer",
  "disclaimer__body": "styles-module-scss-module__uq-5CW__disclaimer__body",
  "disclaimer__bodyStrong": "styles-module-scss-module__uq-5CW__disclaimer__bodyStrong",
  "disclaimer__copy": "styles-module-scss-module__uq-5CW__disclaimer__copy",
  "disclaimer__link": "styles-module-scss-module__uq-5CW__disclaimer__link",
  "disclaimer__logo": "styles-module-scss-module__uq-5CW__disclaimer__logo",
  "disclaimer__logoWrap": "styles-module-scss-module__uq-5CW__disclaimer__logoWrap",
});
